import { ToggleSwitchWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { BROADCAST_VIEW_DIALOG_TEST_ID } from './BroadcastViewDetailDialog';

export namespace BroadcastToggle {
	export interface Props {
		isBroadcast: boolean;
		onToggleSwitch: () => void;
		isToggleAllowed: boolean;
	}
}

export const BroadcastToggle = (props: BroadcastToggle.Props): JSX.Element => {
	return <ToggleSwitchWidget
		textAlign='left'
		onChange={props.onToggleSwitch}
		checked={props.isBroadcast}
		testId={`${BROADCAST_VIEW_DIALOG_TEST_ID}-toggle-btn`}
		children={Messages.broadcastToggleLabel()}
		disabled={!props.isToggleAllowed}
	/>;
};